import {keys, owns} from './object';

const
    objectProto = Object.prototype,

    toString = objectProto.toString,

    slowTypePredicate = type => (
        (name => (
            value => toString.call(value) === name))(
                `[object ${type}]`)),

    fastTypePredicate = (name, type) => (
        (predicate => (
            value => (
                typeof value === name ||
                predicate(value))))(
                    slowTypePredicate(type))),

    isAbsent = value => value === null || value === undefined,

    isArray = Array.isArray,

    isBoolean = fastTypePredicate('boolean', 'Boolean'),

    isDefined = value => value !== undefined,

    isEq = (left, right) => left === right,

    isEqual = (left, right) => {
        if (left === right) {
            return true;
        } else if (left !== null && right !== null) {
            if (isArray(left) && isArray(right)) {
                if (left.length === right.length) {
                    for (let i = 0, length = left.length; i < length; i += 1) {
                        if (left[i] !== right[i]) {
                            return false;
                        }
                    }
                    return true;
                }
            } else if (isPlainObject(left) && isPlainObject(right)) {
                const
                    lkeys = keys(left),
                    rkeys = keys(right);

                if (lkeys.length === rkeys.length) {
                    for (let key of lkeys) {
                        if (!owns(right, key) || left[key] !== right[key]) {
                            return false;
                        }
                    }
                    return true;
                }
            }
        }
        return false;
    },

    isFunction = fastTypePredicate('function', 'Function'),

    isNumber = fastTypePredicate('number', 'Number'),

    isNull = value => value === null,

    isObject = value => Object(value) === value,

    isPlainObject = value => (
        isObject(value) &&
        Object.getPrototypeOf(value) === objectProto),

    isPresent = value => value !== null && value !== undefined,

    isPromise = slowTypePredicate('Promise'),

    isRegex = slowTypePredicate('RegExp'),

    isString = fastTypePredicate('string', 'String'),

    isUndefined = value => value === undefined;

export {
    isAbsent,
    isArray,
    isBoolean,
    isDefined,
    isEq,
    isEqual,
    isFunction,
    isNumber,
    isNull,
    isObject,
    isPlainObject,
    isPresent,
    isPromise,
    isRegex,
    isString,
    isUndefined
};
